import React from 'react';
import ReactDOM from 'react-dom';
import { Global, css } from '@emotion/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';
import App from './App';
import themeConfig from './components/views/themeConfig';
// import * as serviceWorker from './serviceWorker';
import { init, Integrations } from '@sentry/browser';
import { version } from './version.json';

init({
  dsn: 'https://5352221bc51d4e05a019b1ff780c6416@sentry.airwallex.com/64',
  environment: window.location.host,
  integrations: [
    new Integrations.Breadcrumbs({
      console: false,
    }),
    new Integrations.GlobalHandlers({
      onerror: true,
      onunhandledrejection: true,
    }),
  ],
  release: version,
});

console.log('Airwallex Checkout UI | Version', version || '(unspecified)');

ReactDOM.render(
  <ThemeProvider theme={themeConfig({})}>
    <Global
      styles={css`
        // *,
        // *:before,
        // *:after {
        //   user-select: none;
        // }
        body {
          background-color: transparent;
        }
      `}
    />
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <script id="releaseVersion" type="application/json">
      {version}
    </script>
    <App />
  </ThemeProvider>,
  document.getElementById('root') || document.createElement('div'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
